import { render } from "./componentEditLink.vue?vue&type=template&id=234ca8fc"
import script from "./componentEditLink.vue?vue&type=script&lang=js"
export * from "./componentEditLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__